// ABOUTME: Reusable button component to redirect users from old gnowbe-web to new gnowbe-frontend
// ABOUTME: Handles URL mapping to preserve user context when switching apps

import React from 'react'
import { Button } from 'components/utils/Button'
import { trackButtonEnhanced } from 'utils/track'

interface ExploreNewAppButtonProps {
  /** The screen/page name where the button is displayed (for analytics) */
  onScreen?: string
  /** Button type (default: 'gnowbe') */
  type?: 'gnowbe' | 'sub' | 'primary' | 'text' | 'guide' | 'danger' | 'team' | 'quote' | 'edit' | 'chat' | 'ad' | 'magic'
  /** Custom button text (default: 'Explore the New Web App') */
  text?: string
  /** Additional CSS classes */
  className?: string
}

/**
 * Button that redirects users from the old gnowbe-web app to the new gnowbe-frontend app
 * while preserving their current context/view through URL mapping.
 * 
 * When clicked:
 * 1. Tracks analytics event
 * 2. Sets app_version=new cookie (2 year expiration)
 * 3. Maps current URL to equivalent new app URL
 * 4. Redirects to new app
 */
export const ExploreNewAppButton: React.FC<ExploreNewAppButtonProps> = ({
  onScreen = 'Unknown',
  type = 'gnowbe',
  text = 'Explore the New Web App',
  className,
}) => {
  const handleClick = () => {
    // Track button click for analytics
    trackButtonEnhanced({
      button: text,
      onScreen,
    })
    
    // Set cookie app_version=new for 2 years
    const date = new Date()
    date.setTime(date.getTime() + (2 * 365 * 24 * 60 * 60 * 1000))
    document.cookie = `app_version=new; expires=${date.toUTCString()}; path=/`
    
    // Get the mapped URL for the new app and redirect
    window.location.reload()
  }

  return (
    <Button
      type={type}
      text={text}
      onClick={handleClick}
      className={className}
    />
  )
}
